import { render } from "./Cookies.vue?vue&type=template&id=5be69b3e&scoped=true"
const script = {}

import "./Cookies.vue?vue&type=style&index=0&id=5be69b3e&scoped=true&lang=css"

import exportComponent from "/var/www/ca-quiz.staging.mindoza.net/releases/20240705152708/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be69b3e"]])

export default __exports__